import { GetAllEmailGroupsResponse } from 'types/sensors';
import {
  ApiEnveloppe,
  CreateCapteurResponse,
  GetAllCapteurByProjectIdResponse,
  GetAllImportFiltersResponse,
  SensorTypeReponse,
  UpdateCapteurResponse,
} from '../../types/types';
import { _post, requestType } from './_internal';

export const createCapteur = (payload: any): Promise<CreateCapteurResponse> => {
  return _post({ request_type: requestType.creation_d_un_capteur, ...payload });
};

export const updateCapteur = (payload: any): Promise<UpdateCapteurResponse> => {
  return _post({
    request_type: requestType.modification_d_un_capteur,
    ...payload,
  });
};

export const deleteCapteur = (payload: {
  sensor_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_un_capteur,
    sensor_id: payload.sensor_id,
  });
};

export const getSensorTypesList = (): Promise<SensorTypeReponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_sensor_type,
  });
};

// TODO error in backend with the name of the table
export const createSensorType = (payload: {
  sensor_type_name: string;
  sensor_type_display: string;
}) => {
  return _post({
    request_type: requestType.creation_d_un_sensor_type,
    sensor_type_name: payload.sensor_type_name,
    sensor_type_display: payload.sensor_type_display,
  });
};

export const updateSensorType = (payload: any) => {
  return _post({
    request_type: requestType.modification_d_un_sensor_type,
    ...payload,
  });
};

export const deleteSensorType = (payload: {
  sensor_type_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.suppression_d_un_sensor_type,
    sensor_type_id: payload.sensor_type_id,
  });
};

export const getAllCapteurByProjectId = (payload: {
  projects_id: any;
}): Promise<GetAllCapteurByProjectIdResponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_capteurs,
    projects_id: payload.projects_id,
  });
};

export const getAllImportFilters = (): Promise<GetAllImportFiltersResponse> => {
  return _post({
    request_type:
      requestType.recuperation_de_la_liste_des_filtres_d_importation,
  });
};

export const getAllEmailGroups = (): Promise<GetAllEmailGroupsResponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_groupes_d_emails,
  });
};

//TODO not working ?
export const createOrReplaceImageForSensorType = (payload: any) => {
  return _post({
    request_type: requestType.ajouter_une_image_de_type_de_capteur,
    ...payload,
  });
};

export const importSensorBundle = (payload: any) => {
  return _post({
    request_type: requestType.importation_des_capteurs_en_lot,
    ...payload,
  });
};
